import React, { createContext, useReducer } from 'react'

export const SET_PLUGIN_DATA = 'SET_PLUGIN_DATA'
export const UPDATE_PLUGIN_DATA = 'UPDATE_PLUGIN_DATA'
export const SET_SELECTED_PLUGIN_DATA = 'SET_SELECTED_PLUGIN_DATA'
export const SET_SELECTED_IDS = 'SET_SELECTED_IDS'
export const SHOW_DEF_BULK_UPLOAD = 'SHOW_BULK_UPLOAD'
export const SET_UPLOAD_GENERATE_FILE_STATUS = 'SET_UPLOAD_GENERATE_FILE_STATUS'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_PLUGIN_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_PLUGIN_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData }
    }
    case SET_SELECTED_PLUGIN_DATA: {
      return { ...data, selectedObject: payload.data }
    }
    case SET_SELECTED_IDS: {
      let tempSelectedIds = [...data.selectedIds]
      let item = payload.data
      tempSelectedIds.indexOf(item) === -1
        ? tempSelectedIds.push(item)
        : tempSelectedIds.splice(tempSelectedIds.indexOf(item), 1)
      return { ...data, selectedIds: tempSelectedIds }
    }
    case SHOW_DEF_BULK_UPLOAD: {
      return { ...data, show_bulk_upload: payload.data }
    }
    case SET_UPLOAD_GENERATE_FILE_STATUS: {
      return {
        ...data,
        in_process_upload_file_harnesses:
          payload.data.in_process_upload_file_harnesses,
        in_process_generate_file_ids: payload.data.in_process_generate_file_ids,
        failed_due_to_error: payload.data.failed_due_to_error,
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedObject: {},
  selectedIds: [],
  show_bulk_upload: false,
  in_process_upload_file_harnesses: [],
  in_process_generate_file_ids: [],
  failed_due_to_error: [],
}

const PluginStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <PluginContext.Provider value={[state, dispatch]}>
      {children}
    </PluginContext.Provider>
  )
}

export const PluginContext = createContext(initialState)
export default PluginStore
